import cn from 'classnames';
import { outreach } from '@round/api';
import { Badge } from '@round/creatorbase-ui';
import styles from './OutreachStatusBadge.module.css';

/** Shared with the status filter so a status reads the same wherever it is named. */
export const OUTREACH_STATUS_LABELS: Record<outreach.OutreachStatus, string> = {
    submitted: 'Submitted',
    collecting: 'Collecting',
    results_coming_in: 'Results coming in',
    complete: 'Complete',
    cancelled: 'Cancelled',
};

// Each status carries its own tint rather than a generic Badge variant, so where a request sits in the
// pipeline reads at a glance.
const statusClassName: Record<outreach.OutreachStatus, string> = {
    submitted: styles.submitted,
    collecting: styles.collecting,
    results_coming_in: styles.resultsComingIn,
    complete: styles.complete,
    cancelled: styles.cancelled,
};

type Props = {
    status: outreach.OutreachStatus;
};

export const OutreachStatusBadge = ({ status }: Props) => (
    // Later phases add statuses between collecting and complete, so an unknown value falls back to the
    // raw string and the plain badge rather than rendering an empty pill.
    <Badge variant="outline" className={cn(styles.badge, statusClassName[status])}>
        {OUTREACH_STATUS_LABELS[status] ?? status}
    </Badge>
);
